<template>
  <div>
    <v-dialog v-model="existing" persistent max-width="1500" min-height="200">
        <v-card>
            <v-card-title class="grey lighten-2 py-3">
                <h3 class="text-h5">Customer Existing Services</h3>
            </v-card-title>
            <v-card-text>
                <div style="height: 100%">
                    <v-progress-linear
                        v-if="tableLoading"
                        indeterminate
                        color="primary"
                    ></v-progress-linear>
                    <ag-grid-vue
                        domLayout="autoHeight"
                        class="ag-theme-balham mb-2"
                        :columnDefs="columnDefs"
                        :rowData="rowData"
                        :defaultColDef="defaultColDef"
                        @first-data-rendered="onFirstDataRendered"
                    ></ag-grid-vue>
                </div>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="default" @click="$emit(`close`)">Back</v-btn>
                </v-card-actions>
            </v-card-text>
        </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
export default {
    name: "existing-services",
    props:{
        existing: {
            type: Boolean,
            default: () => false,
        },
        tableLoading: {
            type: Boolean,
            default: () => true,
        },
        rowData: {
            type: Array,
            default: () => [],
        }
    },
    components:{
     AgGridVue
    },
    data: () => ({
        columnDefs: [],
    }),
    beforeMount() {
        let vm = this
        vm.setColumnDefs();
        vm.defaultColDef = {
            resizable: true,
            autoHeight: true
        };
    },
    methods: {
        setColumnDefs() {
            let vm = this;
            vm.columnDefs = [
                { headerName: "Type", field: "type",},
                { headerName: "Service", field: "service",},
                { headerName: "Plan", field: "plan",},
                { headerName: "Name", field: "name",},
                { headerName: "Added", field: "added",
                    filter: true,
                    valueFormatter: (param) => {
                    return vm.$options.filters.formatDate(param.value);
                    },
                },
                { headerName: "Released", field: "released",
                    filter: true,
                    valueFormatter: (param) => {
                    return vm.$options.filters.formatDate(param.value);
                    },
                },
                { headerName: "Contract End", field: "contractEnd",
                    filter: true,
                    valueFormatter: (param) => {
                    return vm.$options.filters.formatDate(param.value);
                    },
                },
            ];
        },
        onFirstDataRendered (grid) {
            grid.api.sizeColumnsToFit();
        },
    },
    filters: {
        formatDate(date) {
        if (!date) return null;

        const [year, month, day] = date.substring(0, 10).split("-");
        return `${day}/${month}/${year}`;
        },
    }
}
</script>
